import React  from 'react';
import { PayloadStates } from '@lore/utils';
import TextField from './TextField';
import useMissingFields from '../useMissingFields';

export default function MissingFields(props) {
  const { project } = props;

  const { missingFields } = useMissingFields(project);

  if (missingFields.state === PayloadStates.FETCHING) {
    return (
      <TextField label="Missing Fields">
        ...
      </TextField>
    );
  }

  return (
    <TextField label="Missing Fields">
      {missingFields.data.map(function(field) {
        return field.label;
      }).join(', ')}
    </TextField>
  );
}
